import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  Button,
  Grid,
  SvgIcon,
  Typography,
} from '@material-ui/core';
import {
  PlusCircle as PlusCircleIcon,
} from 'react-feather';
import { BLOG } from '../../../utils/const/contentTypes';
import useStyles from './styles';

function Header({ className, contentType, ...rest }) {
  const classes = useStyles();
  const isBlog = contentType === BLOG;

  return (
    <Grid
      className={clsx(classes.emptyRoot, className)}
      container
      justifyContent="space-between"
      spacing={3}
      {...rest}
    >
      <Grid item>
        <Typography
          variant="h3"
          color="textPrimary"
        >
          Contenido
        </Typography>
      </Grid>
      <Grid item>
        <Button
          color="secondary"
          variant="contained"
          className={classes.action}
          href={isBlog ? '/administracion/blog/crear' : '/administracion/casos-exito/crear'}
        >
          <SvgIcon
            fontSize="small"
            className={classes.actionIcon}
          >
            <PlusCircleIcon />
          </SvgIcon>
          {isBlog ? 'Nuevo blog' : 'Nuevo caso de éxito'}
        </Button>
      </Grid>
    </Grid>
  );
}

Header.propTypes = {
  className: PropTypes.string,
  contentType: PropTypes.string.isRequired,
};

export default Header;
